import React, { useEffect, useRef } from "react";
import { useSelector } from "react-redux";

const CreateProfileCenterWrapper = ({ children, className }) => {
  const innerStepper = useSelector((state) => state.common?.innerStepperKey);
  const containerRef = useRef(null);
  const scrollToTop = () => {
    containerRef.current.scrollTo(0, 0);
  };
  useEffect(() => {
    if (containerRef?.current) {
      scrollToTop();
    }
  }, [containerRef?.current, className, innerStepper]);
  return (
    <div
      className={`row common-wrapper-details ${className ? className : ""}`}
      ref={containerRef}
    >
      <div className="col-12">{children}</div>
    </div>
  );
};

export default CreateProfileCenterWrapper;
